import http from '@/plugin/axios'
import Form from '@utils/form'
import tableSelect from './config/tableSelect'

async function getData(vm: any) {
  const data = await http({
    url: '/srmCheckApply/getCheckApplyDetail',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { checkApplyNo: vm.$route.params.checkApplyNo }
  })
  vm.setData(data)
  vm.createForm()
}

async function submit(this: any, data: any) {
  return http({
    url: '/srmCheckApply/saveCheckApply',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { ...data, checkApplyNo: this.$route.params.checkApplyNo }
  })
}

export default new Form('ordersupplier.externalcontrol')
  .dataUrl(getData)
  .url(submit)
  .title('formTitle.baseInfo')
  .add('applyDate').merge('date').label('applyDate').required()
  .add('purOfficeNo').select('/purchaseUnit/getPurchaseUnitPage', { usingFlag: '1' }).required()
  .table('bodyList', tableSelect).listRequired()
  .end()
